import * as React from 'react';
import { Header } from './base';
import './deadlineSection.module.scss';
import { MobBr } from '../../../../commonv3/components/atoms/layouts/br';

export const DeadlineSection = () => (
    <div styleName="section">
        <Header>移行の期限について</Header>
        <div styleName="deadline-box">
            移行プランの適用期限<MobBr />
            <span styleName="deadline">
                <span styleName="no">10</span>月<span styleName="no">31</span>日
            </span>
        </div>
        <div styleName="note">※対応されない場合は、11/1から自動でプレミアムプランに切り替わりますのでご注意下さい</div>
    </div>
);
